import axios from 'axios';
import store from '@/store';

// API de Chat com autenticação via token
const chatApi = axios.create({
    baseURL: 'https://api.jobifull.com.br/api',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

// Interceptor para adicionar token de autenticação
chatApi.interceptors.request.use((config) => {
    const token = store.getters.getToken;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Funções da API de Chat com autenticação
export const chatService = {
  // 1. Obter perfil do usuário para o chat
  async getUserProfile() {
    try {
      console.log('🔍 Obtendo perfil do usuário...');
      
      const endpoint = '/chat_message/userprofile';
      console.log('📍 URL da requisição:', endpoint);
      
      const response = await chatApi.get(endpoint);
      console.log('✅ Perfil obtido:', response.data);
      return response;
      
    } catch (error) {
      console.error('❌ Erro ao obter perfil:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw error;
    }
  },

  // 2. Listar usuários disponíveis para chat
  async getAvailableUsers(profileType) {
    try {
      console.log('🔍 Obtendo usuários disponíveis para:', profileType);
      
      const endpoint = `/chat_message/available?profile_type=${profileType}`;
      console.log('📍 URL da requisição:', endpoint);
      
      const response = await chatApi.get(endpoint);
      console.log('✅ Usuários obtidos:', response.data);
      return response;
      
    } catch (error) {
      console.error('❌ Erro ao obter usuários:', error);
      throw error;
    }
  },

  // 3. Listar conversas ativas
  async getConversations(profileType) {
    try {
      console.log('🔍 Obtendo conversas para:', profileType);
      
      const endpoint = `/chat_message/${profileType}/conversations`;
      console.log('📍 URL da requisição:', endpoint);
      
      const response = await chatApi.get(endpoint);
      console.log('✅ Conversas obtidas:', response.data);
      return response;
      
    } catch (error) {
      console.error('❌ Erro ao obter conversas:', error);
      throw error;
    }
  },

  // 4. Enviar mensagem
  async sendMessage(messageData) {
    try {
      console.log('📤 Enviando mensagem:', messageData);
      
      const endpoint = '/chat_message/sendmessage';
      console.log('📍 URL da requisição:', endpoint);
      
      const response = await chatApi.post(endpoint, messageData);
      console.log('✅ Mensagem enviada:', response.data);
      return response;
      
    } catch (error) {
      console.error('❌ Erro ao enviar mensagem:', error);
      throw error;
    }
  },

  // 5. Marcar mensagens como lidas
  async markAsRead(profileType, conversationId) {
    try {
      console.log('👁️ Marcando como lido:', { profileType, conversationId });
      
      const endpoint = `/chat_message/${profileType}/markasread`;
      console.log('📍 URL da requisição:', endpoint);
      
      const response = await chatApi.post(endpoint, { conversation_id: conversationId });
      console.log('✅ Marcado como lido:', response.data);
      return response;
      
    } catch (error) {
      console.error('❌ Erro ao marcar como lido:', error);
      throw error;
    }
  },

  // 6. Listar mensagens de uma conversa
  async getConversationMessages(conversationId) {
    try {
      console.log('🔍 Obtendo mensagens da conversa:', conversationId);
      
      const endpoint = `/chat_message/conversationmessages?conversation_id=${conversationId}`;
      console.log('📍 URL da requisição:', endpoint);
      
      const response = await chatApi.get(endpoint);
      console.log('✅ Mensagens obtidas:', response.data);
      return response;
      
    } catch (error) {
      console.error('❌ Erro ao obter mensagens:', error);
      throw error;
    }
  }
};

export default chatApi;
